function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as ActiveStorage from '@rails/activestorage';
var DirectUpload = ActiveStorage.DirectUpload;
import './file.scss';
import CustomHTMLElement from 'html-element';
import { createUrlQueryString, decodeUrlQueryString } from 'js-api';
import SpriteSvg from '../svg';
export var FileInput = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(FileInput, _CustomHTMLElement);

  var _super = _createSuper(FileInput);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _super.apply(this, arguments);
  }

  _createClass(FileInput, [{
    key: "_runSetup",
    value: function _runSetup() {
      _get(_getPrototypeOf(FileInput.prototype), "_runSetup", this).call(this);

      this.input = this.querySelector('input[type=file]');
      this.hiddenInput = this.querySelector('input[type=hidden]');
      var fileTypes = this.input.accept;

      if (typeof fileTypes === 'string' && fileTypes.length > 0) {
        this.fileTypes = fileTypes.split(',');
      } else {
        this.fileTypes = null;
      }

      this.multiple = this.input.multiple;
      this.name = this.input.name;
      this.activeStorageEnabled = this.getBooleanAttribute('data-active-storage');
      this.uploadParams = this.getJsonAttribute('data-upload-params');
      this.setupInput();
      this.setupDragDrop();

      if (!this.activeStorageEnabled) {
        this.hiddenInput.remove();
      }
    } ////////// File

  }, {
    key: "fileElements",
    get: function get() {
      return this.querySelectorAll('file-input-file');
    }
  }, {
    key: "processInputFiles",
    value: function processInputFiles(files) {
      var _this = this;

      files.forEach(function (file) {
        _this.addFile(file);
      });

      if (this.activeStorageEnabled) {
        this.input.value = '';
      }
    }
  }, {
    key: "processDroppedFiles",
    value: function processDroppedFiles(files) {
      var _this2 = this;

      files.forEach(function (file) {
        _this2.addFile(file);
      });
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      if (!this.multiple) {
        var currentFiles = this.fileElements;
        currentFiles.forEach(function (f) {
          return f.remove();
        });
      }

      var fileElement = new FileInputFile(file, this.name);
      this.append(fileElement);
    }
  }, {
    key: "addFileError",
    value: function addFileError(_error) {
      var element = document.createElement('div');
      element.classList.add('form__field__note');
      element.classList.add('form__field__note--error');
      element.innerText = 'There was an error uploading the file';
      this.parentElement.appendChild(element);
    } ////////// Manual

  }, {
    key: "setupInput",
    value: function setupInput() {
      var _this3 = this;

      this.input.addEventListener('change', function (_event) {
        var files = Array.from(_this3.input.files);

        _this3.processInputFiles(files);
      });
    } ////////// Drag and Drop

  }, {
    key: "setupDragDrop",
    value: function setupDragDrop() {
      var _this4 = this;

      this.addEventListener('dragenter', function (_event) {
        _this4.classList.add('file-input--dragover');
      });
      this.addEventListener('dragleave', function (_event) {
        _this4.classList.remove('file-input--dragover');
      });
      this.addEventListener('drop', function (event) {
        _this4.classList.remove('file-input--dragover');

        var files = Array.from(event.dataTransfer.files);

        _this4.processDroppedFiles(files);

        event.preventDefault();
        return false;
      });
    }
  }]);

  return FileInput;
}(CustomHTMLElement);
export var FileInputFile = /*#__PURE__*/function (_CustomHTMLElement2) {
  _inherits(FileInputFile, _CustomHTMLElement2);

  var _super2 = _createSuper(FileInputFile);

  function FileInputFile() {
    _classCallCheck(this, FileInputFile);

    return _super2.apply(this, arguments);
  }

  _createClass(FileInputFile, [{
    key: "_runSetup",
    value: function _runSetup(file, name) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _get(_getPrototypeOf(FileInputFile.prototype), "_runSetup", this).call(this);

      if (file) {
        this.file = file;
        this.name = name;
        this.markedForCreation = true;
        this.classList.add('file-input-file--creating');
        var spanElement = document.createElement('span');
        spanElement.innerHTML = file.name;
        this.appendChild(spanElement);
        this.uploadParams = options.uploadParams || null;
        this.skipHiddenField = options.skipHiddenField || false;
      } else {
        this.hiddenField = this.querySelector('input[type=hidden]');
      }

      this.createButton();
    }
  }, {
    key: "fileInput",
    get: function get() {
      return this.closest('file-input');
    }
  }, {
    key: "createProgressElement",
    value: function createProgressElement() {
      this.progressElement = document.createElement('div');
      this.progressElement.classList.add('file-input-file__progress');
      this.appendChild(this.progressElement);
    }
  }, {
    key: "createHiddenField",
    value: function createHiddenField() {
      if (!this.blob || this.hiddenField || this.skipHiddenField) return;
      this.hiddenField = document.createElement('input');
      this.hiddenField.name = this.name;
      this.hiddenField.setAttribute('type', 'hidden');
      this.hiddenField.setAttribute('value', this.blob.signed_id);
      this.appendChild(this.hiddenField);
    }
  }, {
    key: "removeHiddenField",
    value: function removeHiddenField() {
      if (!this.hiddenField) return;
      this.hiddenField.remove();
      this.hiddenField = null;
    }
  }, {
    key: "createButton",
    value: function createButton() {
      var _this5 = this;

      this.iconElement = new SpriteSvg();
      this.iconElement.iconName = 'icon_cross';
      var buttonElement = document.createElement('a');
      buttonElement.classList.add('file-input-file__button');
      buttonElement.appendChild(this.iconElement);
      buttonElement.addEventListener('click', function (_event) {
        return _this5.buttonClicked();
      });
      this.appendChild(buttonElement);
    } ////////// Add/Remove

  }, {
    key: "buttonClicked",
    value: function buttonClicked() {
      if (this.file) {
        this.remove();
      } else {
        if (this.markedForDeletion) {
          this.resetDeletion();
        } else {
          this.markForDeletion();
        }
      }
    }
  }, {
    key: "markForDeletion",
    value: function markForDeletion() {
      this.classList.add('file-input-file--deleting');
      this.markedForDeletion = true;
      this.iconElement.iconName = 'icon_plus';
      this.hiddenField.remove();
    }
  }, {
    key: "resetDeletion",
    value: function resetDeletion() {
      this.classList.remove('file-input-file--deleting');
      this.markedForDeletion = false;
      this.iconElement.iconName = 'icon_cross';
      this.appendChild(this.hiddenField);
    } ////////// Uploading

  }, {
    key: "upload",
    value: function upload() {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (!_this6.fileInput.activeStorageEnabled) {
          _this6.markedForCreation = false;
          return resolve(null);
        }

        if (!_this6.file) {
          return reject(new Error('There is no file to upload'));
        }

        if (_this6.blob) {
          return reject(new Error('The file has already been uploaded'));
        }

        _this6.createProgressElement();

        _this6.classList.add('file-input-file--uploading');

        _this6.classList.remove('file-input-file--creating');

        var uploadParams = _this6.uploadParams || _this6.fileInput.uploadParams;
        var url = window.config.fileUploadUrl;

        if (_typeof(uploadParams) === 'object') {
          var urlQuery = url.split('?')[1];
          var urlParams = {};

          if (urlQuery && urlQuery.length > 0) {
            urlParams = decodeUrlQueryString(urlQuery);
          }

          Object.assign(urlParams, uploadParams);
          url = url.replace(/(\?.*|$)/, "?".concat(createUrlQueryString(urlParams)));
        }

        var upload = new DirectUpload(_this6.file, url, _this6);
        upload.create(function (error, blob) {
          _this6.progressElement.remove();

          _this6.progressElement = null;

          if (error) {
            _this6.directUploadDidError(error);

            reject(error);
          } else {
            _this6.directUploadDidFinish(blob);

            resolve(blob);
          }
        });
      });
    }
  }, {
    key: "directUploadWillStoreFileWithXHR",
    value: function directUploadWillStoreFileWithXHR(request) {
      var _this7 = this;

      request.upload.addEventListener('progress', function (event) {
        _this7.directUploadDidProgress(event);
      });
    }
  }, {
    key: "directUploadDidProgress",
    value: function directUploadDidProgress(event) {
      var progress = event.loaded / event.total * 100;
      this.progressElement.style.width = "".concat(progress, "%");
    }
  }, {
    key: "directUploadDidError",
    value: function directUploadDidError(error) {
      this.classList.add('file-input-file--error');
      this.classList.remove('file-input-file--uploading');
      this.parentElement.addFileError(error);
    }
  }, {
    key: "directUploadDidFinish",
    value: function directUploadDidFinish(blob) {
      this.classList.add('file-input-file--uploaded');
      this.classList.remove('file-input-file--uploading');
      this.blob = blob;
      this.createHiddenField();
      this.markedForCreation = false;
    }
  }]);

  return FileInputFile;
}(CustomHTMLElement); ////////// Body Dragging

var dragEnterCount = 0;
document.addEventListener('dragenter', function (_event) {
  dragEnterCount += 1;
  document.body.classList.add('file-dragging');
});
document.addEventListener('dragleave', function (_event) {
  if (dragEnterCount <= 1) {
    dragEnterCount = 0;
    document.body.classList.remove('file-dragging');
  } else {
    dragEnterCount -= 1;
  }
});
document.addEventListener('dragover', function (event) {
  event.stopPropagation();
  event.preventDefault();
  return false;
});
document.addEventListener('drop', function (event) {
  dragEnterCount = 0;
  document.body.classList.remove('file-dragging');
  event.stopPropagation();
  event.preventDefault();
  return false;
});
window.customElements.define('file-input', FileInput);
window.customElements.define('file-input-file', FileInputFile);